import styled from 'styled-components/native';
import { Feather as IconsFE, FontAwesome5 as IconsFA5 } from '@expo/vector-icons';
import { themes } from '../../../design/colors';
import Constants from 'expo-constants';

export const Container = styled.View`
    flex: 1;
`;

export const Content = styled.View`
    padding: 20px;
`;

export const Header = styled.View`
    background-color: ${themes.colors.primary};
    padding: ${Constants.statusBarHeight + 12}px 16px;
    flex-direction: row;
    justify-content: space-between;
    height: 200px;
`;

export const Title = styled.Text`
    color: ${themes.colors.white};
    font-size: 16px;
    font-weight: bold;
`;

export const IconFE = styled(IconsFE)``;

export const IconFA5 = styled(IconsFA5)``;

export const ContainerInfoDelivery = styled.View`
    margin-top: -50px;
    background-color: ${themes.colors.white};
    border-radius: 5px;
`;

export const CardDetails = styled.View`
    background-color: ${themes.colors.white};
    margin-top: ${Constants.statusBarHeight + -150}px;
    shadow-color: ${themes.colors.black};
    shadow-opacity: 0.23px;
    shadow-radius: 10px;
    elevation: 1px;
    padding: 15px;
    border-radius: 5px;
`;

export const ContentTitleCard = styled.View`
    flex-direction: row;
`;

export const DataDelivery = styled.Text`
  color: ${themes.colors.black2};
  font-size: 14px;
`;

export const TitleInfoDelivey = styled.Text`
  color: ${themes.colors.black};
  font-size: 14px;
  font-weight: bold;
`;

export const ContentRecipient = styled.View`
  margin-top: 20px;
`;

export const OrderName = styled.Text`
  color: ${themes.colors.primary};
  font-size: 14px;
  font-weight: bold;
  margin-top: 5px;
  margin-left: 5px;
`;

export const CenterOrderActions = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: space-between;
  background-color: ${themes.colors.white};
  padding: 30px;
  /* border-left-width: 2px;
  border-right-width: 2px;
  border-left-color: ${themes.colors.black1};
  border-right-color: ${themes.colors.black1}; */
`;

export const TextActions = styled.Text`
  color: ${themes.colors.black};
  font-size: 12px;
  text-align: center;
`;

export const CardActions = styled.TouchableOpacity`
  text-align: center;
`;

export const OrderActions = styled.View`
  flex-direction: row;
  justify-content: space-between;
  background-color: ${themes.colors.white};
  padding: 30px;
  border-radius: 5px;
`;

export const ContainerActions = styled.View`
flex-direction: row;
  justify-content: space-around;
  background-color: ${themes.colors.white};
  margin-top: 30px;
  margin-bottom: 10px;
  shadow-color: ${themes.colors.black};
  shadow-opacity: 0.23px;
  shadow-radius: 4px;
  elevation: 1px;
  border-radius: 5px;
`;

export const ContentDates = styled.View`
  margin-top: 20px;
  flex-direction: row;
  justify-content: space-between;
`;

export const DeliveryStatus = styled.View`
  background-color: ${themes.colors.white};
  margin-top: 30px;
  shadow-color: ${themes.colors.black};
  shadow-opacity: 0.23px;
  shadow-radius: 4px;
  elevation: 1px;
  padding: 15px;
  border-radius: 5px;
`;

export const ButtonFinalizeDelivery = styled.TouchableOpacity`
  background-color: ${themes.colors.green1};
  margin-top: 30px;
  height: 50px;
  border-radius: 5px;
`;

export const TextFinalizeDelivery = styled.Text`
  color: ${themes.colors.white};
  flex: 1;
  text-align: center;
  top: 15px;
  font-weight: bold;
  font-size: 16px;
`;